import React from 'react';

import Modal from 'react-modal';

import {
    ModalEconomiaContenido,
    ModalEconomiaCabecera,
    ModalEconomiaTitulo,
    ModalEconomiaSubtitulo,
    BotonCerrarModal,

    ModalSeccion,
    ModalSeccionTitulo,
    ModalAcciones,

    BotonSecundario,

    HistorialLista,
    HistorialPago,
    HistorialPagoCabecera,
    HistorialPagoFecha,
    HistorialPagoMeta,
    HistorialPagoImporte,
    HistorialPagoEstado,
    HistorialPagoAcciones,

    HistorialResumen,
    HistorialResumenItem,
    HistorialResumenLabel,
    HistorialResumenValor,

    HistorialImputaciones,
    HistorialImputacion,
    HistorialObservacion,
    HistorialScroll,

    SinInformacion
} from '../../Css/StyledEstadisticasCobros.js';


Modal.setAppElement('#root');


/*
====================================
FORMATEAR DINERO
====================================
*/

const formatMoney = (value) => {

    return new Intl.NumberFormat(
        'es-AR',
        {
            style: 'currency',
            currency: 'ARS',
            maximumFractionDigits: 0
        }
    ).format(
        Number(value || 0)
    );

};


/*
====================================
FORMATEAR FECHA
====================================
*/

const formatDate = (value) => {

    if (!value) {
        return '—';
    }

    const fecha =
        String(value).substring(0, 10);

    const [
        year,
        month,
        day
    ] = fecha.split('-');

    if (
        !year ||
        !month ||
        !day
    ) {
        return value;
    }

    return `${day}/${month}/${year}`;
};


/*
====================================
MEDIO DE PAGO
====================================
*/

const formatMedioPago = (medio) => {

    if (!medio) {
        return 'Sin especificar';
    }

    return medio
        .replaceAll('_', ' ')
        .toLowerCase()
        .replace(
            /\b\w/g,
            letra =>
                letra.toUpperCase()
        );

};


/*
====================================
HISTORIAL DE COBROS
====================================
*/

const HistorialCobrosModal = ({
    isOpen,
    onClose,
    historial,
    onCorregirCobro,
    anulandoPagoId
}) => {

    const pagos =
        Array.isArray(historial?.pagos)
            ? historial.pagos
            : [];


    return (

        <Modal
            isOpen={isOpen}

            onRequestClose={onClose}

            shouldCloseOnOverlayClick={true}

            shouldCloseOnEsc={true}

            style={{
                overlay: {
                    zIndex: 2000,

                    backgroundColor:
                        'rgba(0, 0, 0, 0.45)',

                    display: 'flex',

                    alignItems: 'center',
                    justifyContent: 'center',

                    padding: '1rem'
                },

                content: {
                    position: 'relative',

                    inset: 'auto',

                    border: 'none',

                    background:
                        'transparent',

                    padding: 0,

                    width: '100%',
                    maxWidth: '700px',

                    maxHeight: '90vh',

                    overflow: 'hidden',

                    boxSizing:
                        'border-box'
                }
            }}
        >

            <ModalEconomiaContenido>


                {/*
                ====================================
                CABECERA
                ====================================
                */}

                <ModalEconomiaCabecera>

                    <div>

                        <ModalEconomiaTitulo>
                            Historial de cobros
                        </ModalEconomiaTitulo>

                        <ModalEconomiaSubtitulo>

                            {
                                pagos.length === 1
                                    ? '1 cobro registrado'
                                    : `${pagos.length} cobros registrados`
                            }

                        </ModalEconomiaSubtitulo>

                    </div>


                    <BotonCerrarModal
                        type="button"
                        onClick={onClose}
                    >
                        ×
                    </BotonCerrarModal>

                </ModalEconomiaCabecera>


                {/*
                ====================================
                PAGOS
                ====================================
                */}
                <HistorialScroll>
                    {pagos.length === 0 ? (

                        <SinInformacion>
                            No hay cobros registrados
                            para este paciente.
                        </SinInformacion>

                    ) : (

                        <HistorialLista>

                            {pagos.map(
                                (pago) => {

                                    const anulado =
                                        pago.estado ===
                                        'ANULADO';


                                    const resumen =
                                        pago.resumen ||
                                        {};


                                    const imputaciones =
                                        Array.isArray(
                                            pago.imputaciones
                                        )
                                            ? pago.imputaciones
                                            : [];


                                    return (

                                        <HistorialPago
                                            key={pago.id}
                                        >


                                            {/*
                                            ====================================
                                            DATOS GENERALES
                                            ====================================
                                            */}

                                            <HistorialPagoCabecera>

                                                <div>

                                                    <HistorialPagoFecha>

                                                        Cobro del {
                                                            formatDate(
                                                                pago.fecha_pago
                                                            )
                                                        }

                                                    </HistorialPagoFecha>


                                                    <HistorialPagoMeta>

                                                        {
                                                            formatMedioPago(
                                                                pago.medio_pago
                                                            )
                                                        }

                                                    </HistorialPagoMeta>


                                                    <HistorialPagoEstado
                                                        $anulado={
                                                            anulado
                                                        }
                                                    >

                                                        {
                                                            anulado
                                                                ? 'Anulado'
                                                                : 'Registrado'
                                                        }

                                                    </HistorialPagoEstado>

                                                </div>


                                                <HistorialPagoImporte>

                                                    {
                                                        formatMoney(
                                                            pago.importe
                                                        )
                                                    }

                                                </HistorialPagoImporte>

                                            </HistorialPagoCabecera>


                                            {/*
                                            ====================================
                                            RESUMEN DEL PAGO
                                            ====================================
                                            */}

                                            <HistorialResumen>

                                                <HistorialResumenItem>

                                                    <HistorialResumenLabel>
                                                        Aplicado
                                                    </HistorialResumenLabel>

                                                    <HistorialResumenValor>

                                                        {
                                                            formatMoney(
                                                                resumen.total_imputado_activo
                                                            )
                                                        }

                                                    </HistorialResumenValor>

                                                </HistorialResumenItem>


                                                <HistorialResumenItem>

                                                    <HistorialResumenLabel>
                                                        Saldo sin aplicar
                                                    </HistorialResumenLabel>

                                                    <HistorialResumenValor>

                                                        {
                                                            formatMoney(
                                                                resumen.saldo_sin_imputar
                                                            )
                                                        }

                                                    </HistorialResumenValor>

                                                </HistorialResumenItem>


                                                <HistorialResumenItem>

                                                    <HistorialResumenLabel>
                                                        Cargos afectados
                                                    </HistorialResumenLabel>

                                                    <HistorialResumenValor>

                                                        {
                                                            resumen.cantidad_cargos_afectados ||
                                                            0
                                                        }

                                                    </HistorialResumenValor>

                                                </HistorialResumenItem>

                                            </HistorialResumen>


                                            {/*
                                            ====================================
                                            IMPUTACIONES
                                            ====================================
                                            */}

                                            {imputaciones.length > 0 ? (

                                                <HistorialImputaciones>

                                                    <ModalSeccionTitulo>
                                                        Aplicaciones del cobro
                                                    </ModalSeccionTitulo>


                                                    {imputaciones.map(
                                                        (
                                                            imputacion
                                                        ) => {

                                                            const cargo =
                                                                imputacion.cargo ||
                                                                {};


                                                            return (

                                                                <HistorialImputacion
                                                                    key={
                                                                        imputacion.id
                                                                    }
                                                                >

                                                                    <div>

                                                                        {
                                                                            formatDate(
                                                                                cargo.fecha_prestacion
                                                                            )
                                                                        }

                                                                        {
                                                                            cargo.concepto
                                                                                ? ` · ${cargo.concepto}`
                                                                                : ''
                                                                        }

                                                                    </div>


                                                                    <strong>

                                                                        {
                                                                            formatMoney(
                                                                                imputacion.importe
                                                                            )
                                                                        }

                                                                    </strong>

                                                                </HistorialImputacion>

                                                            );

                                                        }
                                                    )}

                                                </HistorialImputaciones>

                                            ) : null}


                                            {/*
                                            ====================================
                                            OBSERVACIÓN
                                            ====================================
                                            */}

                                            {pago.observacion ? (

                                                <HistorialObservacion>

                                                    <strong>
                                                        Observación:
                                                    </strong>

                                                    {' '}

                                                    {
                                                        pago.observacion
                                                    }

                                                </HistorialObservacion>

                                            ) : null}


                                            {/*
                                            ====================================
                                            FECHA DE ANULACIÓN
                                            ====================================
                                            */}

                                            {anulado &&
                                            pago.anulado_at ? (

                                                <HistorialObservacion>

                                                    Pago anulado el{' '}

                                                    {
                                                        formatDate(
                                                            pago.anulado_at
                                                        )
                                                    }.

                                                </HistorialObservacion>

                                            ) : null}

                                            {!anulado ? (

                                                <HistorialPagoAcciones>

                                                    <BotonSecundario
                                                        type="button"

                                                        onClick={() =>
                                                            onCorregirCobro?.(
                                                                pago
                                                            )
                                                        }

                                                        disabled={
                                                            anulandoPagoId ===
                                                            pago.id
                                                        }
                                                    >

                                                        {
                                                            anulandoPagoId ===
                                                                pago.id
                                                                ? 'Corrigiendo...'
                                                                : 'Corregir cobro'
                                                        }

                                                    </BotonSecundario>

                                                </HistorialPagoAcciones>

                                            ) : null}

                                        </HistorialPago>

                                    );

                                }
                            )}

                        </HistorialLista>

                    )}
                </HistorialScroll>

                <ModalAcciones>

                    <BotonSecundario
                        type="button"
                        onClick={onClose}
                    >
                        Cerrar
                    </BotonSecundario>

                </ModalAcciones>

            </ModalEconomiaContenido>

        </Modal>

    );

};


export default HistorialCobrosModal;